import FlawDeviceEnv from './FlawDeviceEnv';

export default FlawDeviceEnv;
